import { useEffect, useState } from "react";
import api from "./api";

let cache = null;
let pending = null;
const listeners = new Set();

export function invalidateLookups() { cache = null; pending = null; listeners.forEach((fn) => fn()); }

function fetchAll() {
  if (cache) return Promise.resolve(cache);
  if (!pending) pending = api.get("/lookups").then(({ data }) => { cache = data; return data; }).catch(() => ({}));
  return pending;
}

export function useLookups() {
  const [all, setAll] = useState(cache || {});
  useEffect(() => {
    const load = () => fetchAll().then(setAll);
    load();
    listeners.add(load);
    return () => listeners.delete(load);
  }, []);
  return all;
}

export function useLookupOptions(key) {
  const all = useLookups();
  return (all[key]?.values || []).map((v) => ({ value: v, label: v }));
}

export async function addLookupValue(key, value) {
  const { data } = await api.post(`/lookups/${key}/values`, { value });
  cache = null; pending = null;
  listeners.forEach((fn) => fn());
  return data.value;
}
